import { Link, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth-context";

// Nav links matching the reference design: Space Grotesk 14px, 32px gap, muted when inactive,
// full text colour when active — no pill backgrounds.
const BASE: React.CSSProperties = {
  fontFamily: "'Space Grotesk', sans-serif",
  fontSize: 14,
  textDecoration: "none",
  transition: "color 0.15s",
};
const ACTIVE_COLOR = "var(--text)";
const INACTIVE_COLOR = "var(--text-muted)";

export default function NavLinks() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  // Home is now the workspace too (dashboard merged in), so it stays highlighted for the hub and any
  // workspace section.
  const isHome = pathname === "/home";
  const isExplore = pathname === "/skills" || pathname.startsWith("/skill/");
  const isDocs = pathname.startsWith("/docs");
  const isContact = pathname === "/contact";

  return (
    <nav className="flex items-center" style={{ gap: 32 }}>
      {user && (
        <Link to="/home" style={{ ...BASE, color: isHome ? ACTIVE_COLOR : INACTIVE_COLOR }}>Home</Link>
      )}
      <Link to="/skills" style={{ ...BASE, color: isExplore ? ACTIVE_COLOR : INACTIVE_COLOR }}>Explore</Link>
      <Link to="/docs" style={{ ...BASE, color: isDocs ? ACTIVE_COLOR : INACTIVE_COLOR }}>Docs</Link>
      <Link to="/contact" style={{ ...BASE, color: isContact ? ACTIVE_COLOR : INACTIVE_COLOR }}>Contact</Link>
    </nav>
  );
}
